import $ from 'jquery';
import Chart from 'chart.js';

var chartColors = [
  "#003b2a",
  "#1c4f40",
  "#4e766a",
  "#819d94",
  "#a1d9bf",
  "#e0c9a9",
  "#000000", // generated from here
  "#d3d3d3",
  "#2f4f4f",
  "#556b2f",
  "#8b4513",
  "#800000",
  "#191970",
  "#006400",
  "#708090",
  "#808000",
  "#3cb371",
  "#bc8f8f",
  "#008b8b",
  "#4682b4",
  "#000080",
  "#d2691e",
  "#9acd32",
  "#cd5c5c",
  "#32cd32",
  "#daa520",
  "#8fbc8f",
  "#800080",
  "#d2b48c",
  "#9932cc",
  "#ff0000",
  "#ff8c00",
  "#ffd700",
  "#ffff00",
  "#c71585",
  "#0000cd",
  "#00ff00",
  "#00fa9a",
  "#dc143c",
  "#00ffff",
  "#00bfff",
  "#f4a460",
  "#0000ff",
  "#a020f0",
  "#adff2f",
  "#ff6347",
  "#ff00ff",
  "#db7093",
  "#f0e68c",
  "#6495ed",
  "#dda0dd",
  "#87ceeb",
  "#7b68ee",
  "#ee82ee",
  "#98fb98",
  "#7fffd4",
  "#ff69b4",
];

function pieLegendCallback(chart) {
  var text = [];
  text.push('<div class="' + chart.id + '-legend chart-legend">');
  for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
    if (chart.data.datasets[0].data && chart.data.datasets[0].data.length > 0) {
      text.push(
        '<div class="chart-legend__row"><div class="chart-legend__company"><div class="chart-legend__indicator" style="background-color:' +
          chart.data.datasets[0].backgroundColor[i] +
          '"></div>'
      );
      if (chart.data.labels[i]) {
        text.push(chart.data.labels[i]);
      }
      text.push(
        '</div><div class="chart-legend__value">' +
          chart.data.datasets[0].data[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") +
          " € </div></div>"
      );
    }
  }
  text.push("</div>");
  return text.join("");
}

function generatePieLegend(chart) {
  var pieLegend = document.querySelector("[data-pie-legend]");
  pieLegend.innerHTML = pieLegendCallback(chart);
}

$(document).on("turbo:load", function() {
  var pieChart = $("[data-investments-pie-chart]");
  if (!pieChart.length) return;
  var canvas = pieChart[0];
  var chartData = pieChart.data("chartData");
  if (!chartData || !Array.isArray(chartData) || chartData.length === 0) return;
  var chartLabels = [];
  var chartValues = [];
  for (var i = 0; i < chartData.length; i++) {
    chartLabels.push(chartData[i][0]);
    chartValues.push(chartData[i][1]);
  }
  var chart = new Chart(canvas, {
      type: "pie",
      data: {
        datasets: [
          {
            data: chartValues,
            backgroundColor: chartColors,
            borderWidth: 0,
          },
        ],
        labels: chartLabels,
      },
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          backgroundColor: "#FFF",
          cornerRadius: 0,
          titleFontFamily: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
          bodyFontFamily: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
          titleFontSize: 14,
          bodyFontSize: 14,
          titleMarginBottom: 8,
          xPadding: 10,
          yPadding: 14,
          displayColors: false,
          borderWidth: 1,
          borderColor: "#d9e0e0",
          titleFontColor: "black",
          bodyFontColor: "black",
          caretSize: 8,
          caretPadding: 8,
          callbacks: {
            label: function(tooltipItem, data) {
              var label = data.labels[tooltipItem.index] || "";

              if (label) {
                label += ": ";
              }
              label +=
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €";
              return label;
            },
          },
        },
      },
    });
  var pieLegend = document.querySelector("[data-pie-legend]");
  if (pieLegend) pieLegend.innerHTML = pieLegendCallback(chart);
});
